// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue'
import VueResource from 'vue-resource'
import Vuex from 'vuex'
import VueCarousel from 'vue-carousel'
import * as $$ from 'jquery'

Vue.use(BootstrapVue)
Vue.use(VueResource)
Vue.use(Vuex)
Vue.use(VueCarousel)
Vue.use($$)

window.$ = $$
window.jQuery = $$

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import 'font-awesome/css/font-awesome.css'

// import AnimationStyles from './assets/css/animate.css'

// import RobotoFont from './assets/fonts/roboto_regular_macroman/stylesheet.css'

// import Velocity from 'velocity-animate'
// import _ from 'lodash'

// Import Font Awesome
import * as Icon from 'vue-awesome'
Vue.component('icon', Icon)

// // Import Routes
import router from './router'
import App from './App'
import store from './store'

// create an empty Vue instance for handling events and data transfer between components
window.bus = new Vue()

// import { currency } from './currency'

// Vue.filter('currency', currency)

Vue.http.options.credentials = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  template: '<app/>',
  // Register App Component
  components: {
    app: App
  }
})



// WEBPACK FOOTER //
// ./src/main.js